import { doc, onSnapshot } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions, firestoreDb } from './firebase'
import type { ChatCommandAction, ChatCommandStatus } from '../types/chat'

export type ChatCommandExecutionState = {
  status: ChatCommandStatus
  statusMessage: string
}

export const buildChatCommandExecutionPayload = (command: ChatCommandAction) => ({
  commandId: command.commandId,
  signedPayload: command.signedPayload,
})

export const normalizeChatCommandExecutionState = (
  data: Record<string, unknown> | undefined,
): ChatCommandExecutionState | null => {
  const status = data?.status
  if (status !== 'PENDING' && status !== 'EXECUTED' && status !== 'REJECTED' && status !== 'FAILED') return null
  return {
    status,
    statusMessage: typeof data?.statusMessage === 'string' ? data.statusMessage : '',
  }
}

const executeCallable = httpsCallable<
  { commandId: string; signedPayload: string },
  { commandId: string; status: ChatCommandStatus; alreadyExecuted: boolean }
>(firebaseFunctions, 'verifyCommand')

export const executeChatCommand = async (command: ChatCommandAction) => {
  const result = await executeCallable(buildChatCommandExecutionPayload(command))
  return result.data
}

export const subscribeChatCommand = (
  commandId: string,
  listener: (state: ChatCommandExecutionState) => void,
) => onSnapshot(doc(firestoreDb, 'chat_commands', commandId), (snapshot) => {
  const state = normalizeChatCommandExecutionState(snapshot.data())
  if (state) listener(state)
})
